export default __webpack_public_path__ + "static/media/wildlife11.8f2e5e77.png";